import { IDictionary, isNullOrUndefined, isValidParameter } from '@bimser/core';
import { Plugins } from '@bimser/studio-core';
import { IDataSource } from '../entities/common';
import { IDataSourceParameter } from '../entities/common/DataSource/IDataSourceParameter';

const parameterTypes = new Set([
	Plugins.Misc.Enums.EConnectionTypes.REST,
	Plugins.Misc.Enums.EConnectionTypes.GPT,
	Plugins.Misc.Enums.EConnectionTypes.SAP
]);

export function getDataSourceParams(dataSource: IDataSource, fieldParams: IDictionary<any>) {
	const requestPayload: IDictionary<any> = {};
	let isValid = true;

	if (parameterTypes.has(dataSource.connectionType)) {
		requestPayload.parameters = dataSource.parameters.map(i => {
			const param = getParametersValueWithValid(i, fieldParams);

			isValid &&= param.isValid;

			return {
				key: i.name,
				value: param.value
			};
		});
	} else {
		dataSource.parameters.forEach(i => {
			const param = getParametersValueWithValid(i, fieldParams);

			if (!isNullOrUndefined(param.value) || i.valueType === 'string') {
				requestPayload[i.name] = param.value;
			}

			isValid &&= param.isValid;
		});
	}

	return {
		requestPayload,
		isValid
	};
}

export function getParametersValueWithValid(
	parameter: IDataSourceParameter,
	fieldParams: IDictionary<any> = {}
) {
	let value = null;
	let isValid: boolean = true;

	if (parameter.valueModifier === 'valueEntry') {
		value = parameter.value;
		isValid = !parameter.isRequired || isValidParameter(parameter.value);
	} else if (parameter.valueModifier === 'fieldSelection') {
		value = fieldParams[parameter.field];
		isValid = !parameter.isRequired || isValidParameter(fieldParams[parameter.field]);
	}

	return {
		value,
		isValid
	};
}
